import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import NewWebinarForm from "components/Admin/StudyGroups/Webinar/NewWebinarForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "services/userInputFormatter";
import shortid from "shortid";
import _ from "lodash";

const { CPD_STATUSES, REF_TYPES, CREATE_WEBINAR_SAGA, MODAL_TYPE_WEBINAR } =
  constants;

const {
  setTempWebinar,
  createWebinarSaga,
  cleanErrors,
  showModal,
  adminPostAssignedUsersSaga,
  loadDisciplinesSaga,
  loadSponsorUsersSuggestionsSaga,
  getStudygroups,
  getZoomAccounts,
  loadSponsorsSuggestionsSaga,
} = actions;

class NewGroupWebinar extends Component {
  static propTypes = {
    createWebinar: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    let tempWebinar = {};

    if (
      props.location.state &&
      props.location.state.from === "addUsersWebinar"
    ) {
      tempWebinar = {
        ...props.tempWebinar,
        ...{
          assigned_ids:
            (props.tempWebinar && props.tempWebinar.assigned_ids) || [],
          assigned_users: props.users,
        },
      };
    }

    this.state = {
      webinar: {
        assigned_ids: [],
        assigned_users: [],
        // sponsor_representative_id: "",
        webinar_type: "online",
        start_date: moment().set("seconds", 0),
        end_date: moment().set("seconds", 0),
        webinar_title: "",
        search_disciplines: [],
        for_event: false,
        generate_qrcode: false,
        status: "published",
        int_cpd_points: "",
        ext_cpd_points: "",
        cpd_points: "external",
        zoom_uid: "",
        vimeo_url: "",
        attachmentType: "",
        ppt_document: "",
        ppt_document_url: "",
        pptDocumentType: "",
        gms_study_days: "",
        duration: "",
        cpd_status: CPD_STATUSES.granted,
        ref_type: REF_TYPES.ICGP,
        icgp_ref: "",
        ipna_ref: "",
        sponsor_ids: [],
        disciplines: [],
        group_id: props.params.id,
        audio_link: "",
        is_sponsored: false,
        sponsorship_value: "",
        zoom_account: "",
        attachmentPreview: "",
        attachmentType: "",
        spd_quizzes_attributes: [
          { __id: shortid.generate(), question: "", correct: false },
        ],
        sessions_attributes: [
          {
            __id: shortid.generate(),
            title: "",
            start_time: moment().set("seconds", 0),
            end_time: moment().set("seconds", 0),
            rooms_attributes: [
              {
                __id: shortid.generate(),
                title: "",
              },
            ],
          },
        ],
        experts_attributes: [
          {
            __id: shortid.generate(),
            name: "",
            expert_type: "",
            location: "",
            expert_avatar_url: "",
            numeration: "",
            presentation_title: "",
          },
        ],
        ...tempWebinar,
      },
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentWillMount() {
    this.props.loadAllSponsors();
    this.props.cleanErrors();
    this.props.adminPostAssignedUsersSaga(this.state.webinar.assigned_ids);
    // this.props.loadAllSponsorUsers();
    this.props.loadDisciplines();
    // this.props.loadStudygroups({}, "all");
    this.props.loadZoomAccounts();
  }

  onSessionAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          sessions_attributes: [
            ...this.state.webinar.sessions_attributes,
            ...[
              {
                __id: shortid.generate(),
                title: "",
                start_time: moment().set("seconds", 0),
                end_time: moment().set("seconds", 0),
                rooms_attributes: [
                  {
                    __id: shortid.generate(),
                    title: "",
                  },
                ],
              },
            ],
          ],
        },
      },
    });
  };

  onSessionRemove = (__id) => {
    let sessions_attributes = this.state.webinar.sessions_attributes.filter(
      (session) => session.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          sessions_attributes,
        },
      },
    });
  };

  onSessionChange = (__id, field, value) => {
    const sessions_attributes = this.state.webinar.sessions_attributes.slice();
    const session = sessions_attributes.find((session) => session.__id == __id);
    session[field] = value;

    const webinarData = {
      ...this.state.webinar,
      ...{
        sessions_attributes,
      },
    };
    this.setState({ webinar: webinarData });
  };

  onSponsorChange = (sponsor_ids) => {
    this.onFieldChange({
      target: {
        name: "sponsor_ids",
        value: (sponsor_ids || []).map((sponsor) => sponsor.value),
      },
    });
  };

  onConsultantOrHD = (allCounties) => {
    let newWebinar = {};

    const selectedAllCounties = _.isEqual(
      allCounties,
      this.state.webinar.counties
    );
    if (!this.state.webinar.counties || !selectedAllCounties) {
      newWebinar = {
        ...newWebinar,
        ...{ counties: allCounties.map((county) => county) },
      };
    }

    if (
      this.state.webinar.ext_cpd_points !== 0 &&
      this.state.webinar.int_cpd_points !== 0
    ) {
      newWebinar = {
        ...newWebinar,
        ...{ ext_cpd_points: 0, int_cpd_points: 0 },
      };
    }

    if (!_.isEmpty(newWebinar)) {
      this.setState({ webinar: { ...this.state.webinar, ...newWebinar } });
    }
  };

  onFieldChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const webinarData = {
      ...this.state.webinar,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 2;
      }

      this.props.loadDisciplines(fieldValue);
    }

    this.setState({ webinar: webinarData });
  };

  // onSponsorUsersChange = (sponsor_representative_id) => {
  //   this.onFieldChange({
  //     target: {
  //       name: "sponsor_representative_id",
  //       value: sponsor_representative_id.value,
  //     },
  //   });
  // };

  onSelectChangeDisciplineWebinar = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };
  onSelectChangeDisciplineWebinarSearch = (disciplines) => {
    this.onFieldChange({
      target: {
        name: "search_disciplines",
        value: (disciplines || []).map(
          (discipline) => discipline.value || discipline.id
        ),
      },
    });
  };

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onSponsoredChange = (e) => {
    const is_sponsored = e.target.value;
    this.onFieldChange({
      target: {
        name: "is_sponsored",
        value: is_sponsored === "true",
      },
    });
  };

  onEventWebinarChange = (e) => {
    const for_event = e.target.value;
    this.onFieldChange({
      target: {
        name: "for_event",
        value: for_event === "true",
      },
    });
  };
  onGenerateQRChange = (e) => {
    const generate_qrcode = e.target.value;
    this.onFieldChange({
      target: {
        name: "generate_qrcode",
        value: generate_qrcode === "true",
      },
    });
  };

  onCpdPointsChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const cpds = {
      ...(this.state.webinar.cpd_points == "internal"
        ? {
            [e.target.name]: input,
            ext_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "external"
        ? {
            [e.target.name]: input,
            int_cpd_points: 0,
          }
        : {}),
      ...(this.state.webinar.cpd_points == "both"
        ? {
            [e.target.name]: input,
          }
        : {}),
    };
    const webinarData = { ...this.state.webinar, ...cpds };

    this.setState({ webinar: webinarData });
  };

  onCpdTypeChange = (e) => {
    const value = e.target.value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        cpd_status: e.target.value,
        ...(value !== CPD_STATUSES.granted
          ? {
              ext_cpd_points: 0,
              int_cpd_points: 0,
              icgp_ref: "",
            }
          : {}),
      },
    });
  };
  onCertificateRefChange = (e) => {
    const value = e.target.value;
    let refType;

    if (value === REF_TYPES.ICGP) {
      refType = {
        icgp_ref: this.state.webinar.icgp_ref || "",
      };
    } else if (value === REF_TYPES.RCPI) {
      refType = {
        rcpi_ref: this.state.webinar.rcpi_ref || "",
      };
    } else {
      refType = {
        ipna_ref: this.state.webinar.ipna_ref || "",
      };
    }

    this.setState({
      webinar: {
        ...this.state.webinar,
        ref_type: e.target.value,
        ...refType,
      },
    });
  };

  onDateChange = (field, value) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        [field]: value,
      },
    };
    this.setState({ webinar: webinarData });
  };

  onWebinarTypeChange = (e) => {
    const webinarData = {
      ...this.state.webinar,
      ...{
        webinar_type: e.target.value,
      },
    };

    this.setState({ webinar: webinarData });
  };

  onQuizAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: [
            ...this.state.webinar.spd_quizzes_attributes,
            ...[{ question: "", correct: false, __id: shortid.generate() }],
          ],
        },
      },
    });
  };

  onQuizRemove = (__id) => {
    const quizzes = this.state.webinar.spd_quizzes_attributes.filter(
      (quiz) => quiz.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: quizzes,
        },
      },
    });
  };

  onQuizChange = (__id, field, value) => {
    let cpdQuiz = this.state.webinar.spd_quizzes_attributes.slice();
    let quiz = cpdQuiz.find((webinar) => webinar.__id == __id);
    quiz[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          spd_quizzes_attributes: cpdQuiz,
        },
      },
    });
  };

  // Expert CRUD
  onExpertAdd = () => {
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: [
            ...this.state.webinar.experts_attributes,
            ...[
              {
                name: "",
                type: "",
                location: "",
                avatar: "",
                __id: shortid.generate(),
              },
            ],
          ],
        },
      },
    });
  };

  onExpertRemove = (__id) => {
    const experts = this.state.webinar.experts_attributes.filter(
      (expert) => expert.__id != __id
    );
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onExpertChange = (__id, field, value) => {
    let experts = this.state.webinar.experts_attributes.slice();
    let expert = experts.find((webinar) => webinar.__id == __id);
    expert[field] = value;
    this.setState({
      webinar: {
        ...this.state.webinar,
        ...{
          experts_attributes: experts,
        },
      },
    });
  };

  onPptDocumentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: file,
            ppt_document_url: URL.createObjectURL(file),
            pptDocumentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            ppt_document: null,
            ppt_document_url: "",
            pptDocumentType: "",
          },
        },
      });
    }
  };

  cpdPointsFields = () => {
    const { cpd_points, cpd_status } = this.state.webinar;
    if (cpd_status !== CPD_STATUSES.granted) {
      return [];
    }
    switch (cpd_points) {
      case "external":
        return ["ext_cpd_points"];
      case "internal":
        return ["int_cpd_points"];
      case "both":
        return ["int_cpd_points", "ext_cpd_points"];
      default:
        return [];
    }
  };

  onSubmit = () => {
    this.state.webinar.log;
    this.props.createWebinar(this.state.webinar);
  };

  goToAddUsersPage = () => {
    this.props.setTempWebinar(this.state.webinar);
    this.props.router.push(
      `/groups/${this.props.params.id}/webinars/new/addUsers`
    );
  };

  showUsersModal = (additional = {}) => {
    this.props.showUsersModal(
      {
        users: this.props.users,
      },
      additional
    );
  };

  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    const reorder = (list, startIndex, endIndex) => {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    };

    const speakers = reorder(
      this.state.webinar.experts_attributes,
      result.source.index,
      result.destination.index
    ).map((speaker, index) => {
      speaker.numeration = index + 1;
      return speaker;
    });

    this.setState({
      ...this.state,
      webinar: {
        ...this.state.webinar,
        experts_attributes: speakers,
        experts: speakers.filter((speaker) => speaker.expert_type),
      },
    });
  }

  onAttachmentChange = (file) => {
    if (Boolean(file)) {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: file,
            attachmentPreview: URL.createObjectURL(file),
            attachmentType: file.type,
          },
        },
      });
    } else {
      this.setState({
        webinar: {
          ...this.state.webinar,
          ...{
            document: null,
            attachmentPreview: "",
            attachmentType: "",
          },
        },
      });
    }
  };

  render() {
    const { errors, errorsFrontend, studygroups } = this.props;
    const groups = (studygroups || []).map((group) => ({
      value: group.id,
      label: group.title,
    }));

    return (
      <main className="site--width clearfix-c">
        <NewWebinarForm
          role={this.props.role}
          onFieldChange={this.onFieldChange}
          webinar={this.state.webinar}
          onQuizAdd={this.onQuizAdd}
          onQuizChange={this.onQuizChange}
          onDateChange={this.onDateChange}
          onSubmit={this.onSubmit}
          onQuizRemove={this.onQuizRemove}
          errors={validator.formatErrors(errors, errorsFrontend)}
          cpdPointsFields={this.cpdPointsFields()}
          onCpdPointsChange={this.onCpdPointsChange}
          onCpdTypeChange={this.onCpdTypeChange}
          onSponsorUsersChange={this.onSponsorUsersChange}
          onSponsorChange={this.onSponsorChange}
          sponsorsOptions={this.props.sponsors}
          onSponsoredChange={this.onSponsoredChange}
          goToAddUsersPage={this.goToAddUsersPage}
          showUsersModal={this.showUsersModal}
          sponsorUsersOptions={this.props.sponsorUsers}
          onConsultantOrHD={this.onConsultantOrHD}
          onCertificateRefChange={this.onCertificateRefChange}
          onWebinarTypeChange={this.onWebinarTypeChange}
          onExpertAdd={this.onExpertAdd}
          onExpertRemove={this.onExpertRemove}
          onExpertChange={this.onExpertChange}
          onAttachmentChange={this.onAttachmentChange}
          attachmentPreview={this.state.webinar.attachmentPreview}
          attachmentType={this.state.webinar.attachmentType}
          onPptDocumentChange={this.onPptDocumentChange}
          ppt_document_url={this.state.webinar.ppt_document_url}
          pptDocumentType={this.state.webinar.pptDocumentType}
          disciplines={this.props.disciplines}
          onSelectChangeDiscipline={this.onSelectChangeDisciplineWebinar}
          onSelectChangeDisciplineSearch={
            this.onSelectChangeDisciplineWebinarSearch
          }
          onEventWebinarChange={this.onEventWebinarChange}
          search_disciplines={this.props.search_disciplines}
          onDragEnd={this.onDragEnd}
          onGenerateQRChange={this.onGenerateQRChange}
          studygroups={groups}
          zoomAccounts={this.props.zoomAccounts}
          onSessionAdd={this.onSessionAdd}
          onSessionRemove={this.onSessionRemove}
          onSessionChange={this.onSessionChange}
          onRoomAdd={this.onRoomAdd}
          onRoomRemove={this.onRoomRemove}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    tempWebinar: state.webinars.tmp,
    users: state.users.assignedUsers.values,
    errors: state.errors[CREATE_WEBINAR_SAGA],
    errorsFrontend: state.errors[`${CREATE_WEBINAR_SAGA}_FRONTEND`],
    disciplines: state.disciplines.list.values,
    search_disciplines: state.disciplines.search.values,
    count: state.disciplines.list.count,
    total_pages: state.disciplines.list.total_pages,
    page: state.disciplines.list.page,
    query: state.disciplines.list.query,
    sponsorUsers: state.suggestions.sponsorUsers.values,
    role: state.users.user.role,
    studygroups: state.studygroups.studygroups.values,
    zoomAccounts: state.zoom.zoomAccounts,
    sponsors: state.suggestions.sponsor.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTempWebinar: (webinar) => dispatch(setTempWebinar(webinar)),
    createWebinar: (webinar) => dispatch(createWebinarSaga(webinar)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_WEBINAR_SAGA)),
    showUsersModal: (contentProps) =>
      dispatch(showModal(MODAL_TYPE_WEBINAR, contentProps)),
    adminPostAssignedUsersSaga: (assigned_ids, onlyAssigned = true) =>
      dispatch(
        adminPostAssignedUsersSaga(assigned_ids, onlyAssigned, 1, {}, 500)
      ),
    dispatch: dispatch,
    loadDisciplines: (userType) =>
      dispatch(loadDisciplinesSaga(1, { discipline_type: userType })),
    loadAllSponsorUsers: (search, params) =>
      dispatch(loadSponsorUsersSuggestionsSaga(search, params)),
    loadStudygroups: (query, page) => dispatch(getStudygroups(query, page)),
    loadZoomAccounts: () => dispatch(getZoomAccounts()),
    loadAllSponsors: () => dispatch(loadSponsorsSuggestionsSaga()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewGroupWebinar);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/NewGroupWebinar.jsx